/**
 * podravka.io
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.7.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import AttributeDefinitionCreate from '../model/AttributeDefinitionCreate';
import AttributeDefinitionList from '../model/AttributeDefinitionList';
import AttributeDefinitionRead from '../model/AttributeDefinitionRead';
import BadRequestError from '../model/BadRequestError';
import ForbiddenError from '../model/ForbiddenError';
import NotAcceptableError from '../model/NotAcceptableError';
import NotFoundError from '../model/NotFoundError';
import UnauthorizedError from '../model/UnauthorizedError';

/**
* AttributeDefinition service.
* @module api/AttributeDefinitionApi
* @version 1.7.2
*/
export default class AttributeDefinitionApi {

    /**
    * Constructs a new AttributeDefinitionApi. 
    * @alias module:api/AttributeDefinitionApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the createAttributeDefinition operation.
     * @callback module:api/AttributeDefinitionApi~createAttributeDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeDefinitionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a AttributeDefinition resource.
     * To use extended attributes in resources, i.e. amend them with additional custom fields, an attribute definition must first be created, which specifies the name, scope, type, and options of such a definition. Supported scopes are `client`, which means that all users within that client can read and set values for these attributes, and `client+user`, which means that the attribute is private to the user which created it's definition.  Supported types are: * array * bool * date * datetime * numeric * object * reference * string * url  Each type has different configurable options, which additionally describe the attribute definition. Usage examples of all types when working with the actual resources are included at the very end of this document.  **Array example:** ```json {     \"scope\": \"client\",     \"name\": \"example_collection\",     \"type\": \"array\",     \"options\": {         \"type\": \"string\",         \"min\": 3,         \"max\": 6     } } ```  The example above demonstrates how to create an array attribute definition, which will contain multiple string values when used in a resource. The options specify that there must be at least 3 items in the collection, and no more than 6. Supported types of values to be contained in the collection are: bool, date, datetime, numeric, object, reference, string, url.  **Boolean example:** ```json {     \"scope\": \"client+user\",     \"name\": \"is_featured\",     \"type\": \"bool\",     \"required\": true } ```  The example above demonstrates how to create a required boolean attribute definition, which will contain a boolean value (true/false) when used in a resource.  **Date example:** ```json {     \"scope\": \"client+user\",     \"name\": \"birthday\",     \"type\": \"date\" } ```  The example above demonstrates how to create a date attribute definition, which will contain a date value when used in a resource.  **Datetime example:** ```json {     \"scope\": \"client\",     \"name\": \"last_accessed_at\",     \"type\": \"datetime\" } ```  The example above demonstrates how to create a datetime attribute definition, which will contain a datetime value when used in a resource.  **Numeric example:** ```json {     \"scope\": \"client\",     \"name\": \"times_accessed\",     \"type\": \"numeric\" } ```  The example above demonstrates how to create a numeric attribute definition, which will contain a numeric value when used in a resource.  **Object example:** ```json {     \"scope\": \"client+user\",     \"name\": \"arbitrary_object\",     \"type\": \"object\" } ```  The example above demonstrates how to create an object attribute definition, which will contain an arbitrary object when used in a resource.  **Reference example:** ```json {     \"scope\": \"client+user\",     \"name\": \"my_favorite_article\",     \"type\": \"reference\",     \"required\": true,     \"options\": {         \"entity\": \"article\"     } } ```  The example above demonstrates how to create a required reference attribute definition, which will contain a reference to a single resource supported by the application, such as an article, image, file, product etc., when used in a resource.  **String example:** ```json {     \"scope\": \"client+user\",     \"name\": \"personal_notes\",     \"type\": \"string\" } ```  The example above demonstrates how to create a string attribute definition, which will contain a string value when used in a resource.  **Url example:** ```json {     \"scope\": \"client\",     \"name\": \"external_link\",     \"type\": \"url\" } ```  The example above demonstrates how to create an url attribute definition, which will contain an url value when used in a resource.  ---  **Usage example in resources:**  The following is an example of creating an article and setting the extended attribute values as defined in all the examples above.  ```json {     \"title\": \"This is an example article\",     \"extended_attributes\": {         \"user\": {             \"is_featured\": true,             \"birthday\": \"1969-06-21\",             \"arbitrary_object\": {                 \"lorem\": \"ipsum\",                 \"dolor\": [10, 20, 30]             },             \"my_favorite_article\": \"de7b023c-96d8-11e7-abc4-cec278b6b50a\",             \"personal_notes\": \"This is a test...\"         },         \"example_collection\": [             \"lorem\", \"ipsum\", \"dolor\"         ],         \"last_accessed_at\": \"1969-06-21T20:17:00Z\",         \"times_accessed\": 71,         \"external_link\": \"https://example.com\"     } } ``` 
     * @param {module:model/String} entity The entity type
     * @param {module:model/AttributeDefinitionCreate} attributeDefinition Required properties are: * scope * name * type 
     * @param {module:api/AttributeDefinitionApi~createAttributeDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeDefinitionRead}
     */
    createAttributeDefinition(entity, attributeDefinition, callback) {
      let postBody = attributeDefinition;
      // verify the required parameter 'entity' is set
      if (entity === undefined || entity === null) {
        throw new Error("Missing the required parameter 'entity' when calling createAttributeDefinition");
      }
      // verify the required parameter 'attributeDefinition' is set
      if (attributeDefinition === undefined || attributeDefinition === null) {
        throw new Error("Missing the required parameter 'attributeDefinition' when calling createAttributeDefinition");
      }

      let pathParams = {
        'entity': entity
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = ['application/json', 'text/html'];
      let accepts = ['application/json', 'text/html'];
      let returnType = AttributeDefinitionRead;
      return this.apiClient.callApi(
        '/attributes/{entity}', 'POST',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the deleteAttributeDefinition operation.
     * @callback module:api/AttributeDefinitionApi~deleteAttributeDefinitionCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Removes the AttributeDefinition resource.
     * @param {module:model/String} entity The entity type
     * @param {String} id 
     * @param {module:api/AttributeDefinitionApi~deleteAttributeDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     */
    deleteAttributeDefinition(entity, id, callback) {
      let postBody = null;
      // verify the required parameter 'entity' is set
      if (entity === undefined || entity === null) {
        throw new Error("Missing the required parameter 'entity' when calling deleteAttributeDefinition");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling deleteAttributeDefinition");
      }

      let pathParams = {
        'entity': entity,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['*/*', 'application/json'];
      let returnType = null;
      return this.apiClient.callApi(
        '/attributes/{entity}/{id}', 'DELETE',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getAttributeDefinition operation.
     * @callback module:api/AttributeDefinitionApi~getAttributeDefinitionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/AttributeDefinitionRead} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves a AttributeDefinition resource.
     * @param {module:model/String} entity The entity type
     * @param {String} id 
     * @param {module:api/AttributeDefinitionApi~getAttributeDefinitionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/AttributeDefinitionRead}
     */
    getAttributeDefinition(entity, id, callback) {
      let postBody = null;
      // verify the required parameter 'entity' is set
      if (entity === undefined || entity === null) {
        throw new Error("Missing the required parameter 'entity' when calling getAttributeDefinition");
      }
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getAttributeDefinition");
      }

      let pathParams = {
        'entity': entity,
        'id': id
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = AttributeDefinitionRead;
      return this.apiClient.callApi(
        '/attributes/{entity}/{id}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the getAttributeDefinitionList operation.
     * @callback module:api/AttributeDefinitionApi~getAttributeDefinitionListCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/AttributeDefinitionList>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Retrieves the list of AttributeDefinition resources.
     * @param {module:model/String} entity The entity type
     * @param {Object} opts Optional parameters
     * @param {Number} opts.page The list page number
     * @param {module:api/AttributeDefinitionApi~getAttributeDefinitionListCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/AttributeDefinitionList>}
     */
    getAttributeDefinitionList(entity, opts, callback) {
      opts = opts || {};
      let postBody = null;
      // verify the required parameter 'entity' is set
      if (entity === undefined || entity === null) {
        throw new Error("Missing the required parameter 'entity' when calling getAttributeDefinitionList");
      }

      let pathParams = {
        'entity': entity
      };
      let queryParams = {
        'page': opts['page']
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['oauth'];
      let contentTypes = [];
      let accepts = ['application/json', 'text/html'];
      let returnType = [AttributeDefinitionList];
      return this.apiClient.callApi(
        '/attributes/{entity}', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
